import { useGetDemoQuery, useUpdateDemoMutation } from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { usePermissionsContext } from '../../utils';
import { InfoPageEditableTitle } from '../InfoPageEditableTitle';
import { useDemoOrOverlayProps } from '../useDemoOrOverlayProps';

export const DemoPageTitle = () => {
  const { organizationId, demoId, workspaceId, readOnly } =
    useDemoOrOverlayProps();
  const { data: demo } = useGetDemoQuery({
    organizationId,
    workspaceId,
    id: demoId,
  });
  const [updateDemo] = useUpdateDemoMutation();
  const { getPermissions } = usePermissionsContext();

  const updateDemoPermission = getPermissions(
    PermissionKey.demo,
    PermissionAction.updateDemoById
  );
  return (
    <InfoPageEditableTitle
      title={demo?.demoName}
      onTitleChange={(newDemoName) =>
        newDemoName
          ? updateDemo({
              organizationId,
              workspaceId,
              id: demoId,
              demoName: newDemoName,
            })
          : undefined
      }
      disabled={readOnly || !updateDemoPermission}
    />
  );
};
